<template>
  <form
    action=""
    class="uk-form uk-form-stacked"
    @submit.prevent="submit"
  >
    <slot />
  </form>
</template>

<script>
  export default {
    name: 'FormWrapper',
    methods: {
      submit(e) {
        this.$emit('submit', e);
      }
    }
  };
</script>

<style scoped>

</style>
